import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from '../app-config.service';
import { IPostResponseHF } from '../class/PostResponse';
import { RedactReplyServiceService } from '../service/redact-reply-service.service';
import { IBrandDetailsHF } from '../class/redact';
import { CryptoService } from '../service/CryptoService';
import { AppError } from '../common/class/app-error';
@Component({
  selector: 'app-passcodeverify',
  templateUrl: './passcodeverify.component.html',
  styleUrls: ['./passcodeverify.component.scss']
})
export class PasscodeverifyComponent implements OnInit {

  PasswordForm!: FormGroup;
  destShortURL: string = "";
  submitted = false;
  sentPassword = false;
  invalidPassword = false;
    themeValue:boolean;
  showLogo:boolean=true;
  companyLogoURL:string;
  brandDetails:any;
   crypto: CryptoService;
approvedByPasscode=false;
brandingLoaded = false;
pageLoading = true;      // Initial page load (branding/theme)
showContentLoader = false;
encryptedShortUrl="";
  constructor(private formBuilder: FormBuilder, private user: RedactReplyServiceService, private http: HttpClient
    , private router: Router, private route: ActivatedRoute
    , private translate: TranslateService, private location: Location
    , private sanitizer: DomSanitizer
    , private config: AppConfigService) {
         this.crypto = new CryptoService();

    // Apply language
    this.translate.use("en-us");
  }

  get passFormControls() { return this.PasswordForm.controls; }

ngOnInit() {

  this.pageLoading = true;
  this.showContentLoader = false;

  this.buildForm();

  this.route.params.subscribe(params => {

    this.destShortURL = params.shortURL;

    if (this.destShortURL && this.destShortURL.endsWith('-pwd')) {
        console.log('Approved By Passcode');
this.encryptedShortUrl=this.destShortURL;
        // Remove "-pwd"
        const encryptedValue = this.destShortURL.substring(0,this.destShortURL.length - 4);

        try {
          this.destShortURL = this.crypto.decryptQueryString(
            encryptedValue,
            this.config.preSetEncryptPwdKey,
            this.config.preSetEncryptPwdIVector
          );

          this.approvedByPasscode = true;
        } catch (e) {
          console.error('Decryption failed');
          this.approvedByPasscode = false;

        }
      }
    // Read cached branding immediately
    const branding = localStorage.getItem('brandingDetails');

  if (branding) {

    this.brandDetails = JSON.parse(branding);

    this.themeValue = this.brandDetails.Theme != 2;

    this.showLogo = !!this.brandDetails.LogoSrc;
    this.companyLogoURL = this.brandDetails.LogoSrc || "";
}

    // Refresh branding in background
    this.getBrandingDetails();

  });

}
  buildForm() {
    this.PasswordForm = this.formBuilder.group({
      password: ['', Validators.required]
    });
  }

  VerifyPassword() {
    if (this.PasswordForm.invalid) {
      return;
    }
    this.showContentLoader = true;
    this.user.postapiVerifyPassword(this.destShortURL, this.PasswordForm.value.password)
      .subscribe(resp => {

        const response = resp as IPostResponseHF;
        const result = response.ResultContent;
        let postResponse = result;
        if (response.Status == "Success" && postResponse.Verified.toString() == "true") {
         if (response.ResultContent.TTDT) {
          this.router.navigate(
              ['transactionTerminated'],
              { skipLocationChange: true }
          );
          return;
        }
          this.sentPassword = true;
          localStorage.setItem("passcodeverified", "true");
          if(this.approvedByPasscode == true){
        this.router.navigate([`/protectedtext/${this.encryptedShortUrl}`]);
          }else{
            this.router.navigate([`/protectedtext/${this.destShortURL}`]);
          }

          return;
        }
        else {
           this.showContentLoader = false;
          this.invalidPassword = false;
        }
      })
  }

getBrandingDetails() {

  this.user.postUserInformation(this.destShortURL, 'RD')
    .subscribe(resp => {

      if (!(resp instanceof AppError)) {

        const response = resp as IBrandDetailsHF;

        this.brandDetails = response.ResultContent;

        this.themeValue = this.brandDetails.Theme != 2;

        localStorage.setItem('themeValue', JSON.stringify(this.themeValue));
        localStorage.setItem('brandingDetails', JSON.stringify(this.brandDetails));

        this.showLogo = !!this.brandDetails.LogoSrc;
        this.companyLogoURL = this.brandDetails.LogoSrc || "";
      }

    setTimeout(() => {
  this.pageLoading = false;
}, 2000);

    }, () => {

  setTimeout(() => {
  this.pageLoading = false;
}, 2000);

    });

}
}
